/**
 * @Description 登录
 * @Author cc
 * @Time 2021/06/01
 */
/* HTML */
<template>
	<div class="view-login">
		
		<div class="login">
			
			<!--height: 20px;-->
			<div style="position: relative;top: -60px;height: 20px;margin-bottom: 20px;">
				<div class="systemName">{{projectName}}</div>
			</div>
			
			<div class="login-top">
				<p style="font-size: 20px;color: #fff;line-height: 30px;">账户登录</p>
				<p style="font-size: 14px;color: #b3c3ce;line-height: 20px;">Account login</p>
			</div>
			
			<el-form ref="loginForm" :rules="rules" :model="loginForm" style="padding: 0 52px;">
				<el-form-item prop="username">
					<div class="login-center clearfix">
						<div class="login-center-img" style="left: -2px;"><i class="iconfont el-icon-my_user" style="font-size: 20px;color: #0ba4e4;"></i></div>
						<div class="login-center-input">
							<input type="text" id="username" name="" class="username" v-model="loginForm.username" placeholder="请输入您的账户" autocomplete="off">
						</div>
					</div>
				</el-form-item>
				<el-form-item prop="password">
					<div class="login-center clearfix">
						<div class="login-center-img"><i class="iconfont el-icon-my_mima" style="font-size: 20px;color: #0ba4e4;"></i></div>
						<div class="login-center-img _hidePwd" @click.prevent="togglePwdType()" style="left: auto;right: 8px;cursor: pointer;">
							<i v-if="loginForm.showPwd" class="iconfont el-icon-my_yanjing_xianshi toHideBtn" style="font-size: 20px;color: #000;"></i>
							<i v-else class="iconfont el-icon-my_yanjing toShowBtn" style="font-size: 20px;color: #000;"></i>
						</div>
						<div class="login-center-input">
							<input :type="loginForm.showPwd ? 'text' : 'password'" id="password" name="" class="password" v-model="loginForm.password" placeholder="请输入您的密码" autocomplete="off">
						</div>
					</div>
				</el-form-item>
				<el-form-item prop="vCode" style="display: none;">
					<div class="login-center clearfix">
						<div class="login-center-img" style="top: 3px;"><i class="iconfont el-icon-my_yanzhengma" style="font-size: 22px;line-height: 26px;color: #0ba4e4;"></i></div>
						<div class="login-center-input">
							<input type="text" id="Txtidcode" name="" v-model="loginForm.vCode" placeholder="请输入右侧验证码" autocomplete="off">
							<span id="idcode" class="idcode_span">
								<ValidCode ref="validCode" :refresh="vCodeForm.refresh" :width="vCodeForm.width" :height="vCodeForm.height" :length="vCodeForm.length" v-model="vCodeForm.value"></ValidCode>
							</span>
						</div>
					</div>
				</el-form-item>
				<el-form-item>
					<el-checkbox v-model="loginForm.isFull" :true-label="1" :false-label="0" @change="showFullHandle" style="color: #FFFFFF;">是否全屏显示</el-checkbox>
				<el-checkbox v-if="false" v-model="loginForm.autologin" :true-label="1" :false-label="0" @change="autoLoginHandle" style="color: #FFFFFF;">下次自动登录</el-checkbox>
				</el-form-item>
			</el-form>
			
			<!--<div class="login-center clearfix layui-form-item" style="height: 40px;margin-bottom: 0;line-height: 40px;text-align: center;font-size: 14px;">
				<a href="javascript:void(0);" class="forgetBtn" onclick="forgetPwd()" >忘记密码？</a>
			</div> -->
			
			<!--padding-bottom: 20px;height: 36px;-->
			<div v-show="!$checkEmpty(loginForm.errmsg)" class="login-center clearfix" style="text-align: center; padding: 0; margin: 0;font-size: 14px;line-height: 30px;height: 20px;top: -20px;">
				<span style="color:red">
					<span :class="{errorText: loginForm.errmsg}">{{ loginForm.errmsg }}</span>
				</span>
			</div>
			
			<div class="login-button" style="margin-top: 0px;" @click.prevent="login()" id="submit">登录</div>
			
		</div>
		
		<!-- 选择项目 start -->
		<div class="chose-project-shadow" v-if="filters.visibleFlag">
			<div class="chose-project-box">
				
				<!-- 标题 start -->
				<div class="chose-project-tit">
					<span>请选择要进入的项目：</span>
					<span class="chose-project-close" title="放弃登录" @click="cancleLogin">X</span>
				</div>
				<!-- 标题 end -->
				
				<!-- 内容 start -->
				<div class="chose-project-form">
					<!-- el-form start -->
					<el-form :inline="true" :model="filters" ref="filters">
						<!-- el-form-item start -->
						<el-form-item prop="currProjectId">
							<!-- 单选框 start -->
							<el-radio-group v-model="filters.currProjectId" @change="radioChange">
								<el-radio v-for="item in filters.projects" :key="item.id" :label="item.id">{{ item.name }}</el-radio>
							</el-radio-group>
							<!-- 单选框 end -->
						</el-form-item>
						<!-- el-form-item end -->
					</el-form>
					<!-- el-form end -->
				</div>
				<!-- 内容 end -->
				
				<!-- 按钮 start -->
				<div class="chose-project-btns">
					<el-button type="info" size="mini" @click="cancleLogin">放弃登录</el-button>
					<el-button type="primary" size="mini" plain @click="intoProject">进入项目</el-button>
				</div>
				<!-- 按钮 end -->
				
			</div>
		</div>
		<!-- 选择项目 end -->
		
		<!-- 授权 dialog start -->
		<WarrantDialog ref="warrantDialog" :publicKey="publicKey" @storeLoginInfo="storeLoginInfo" />
		<!-- 授权 dialog end -->
		
	</div>
</template>

/* JS */
<script>
	
	// 引入store
	import {mapMutations} from 'vuex'
	import Secret from '@/secret'
	import GlobalFun from '@/global/global-function'
	import {checkEmpty, validFormat, checkFormat} from '@/global/global-valid'
	
	import ApiOam from '@/request/api-oam'
	
	// 引入 组件
	import ValidCode from '@/components/ValidCode/ValidCode'
	// 组件 授权
	import WarrantDialog from '@/components_index/License/WarrantDialog'
	
	// 对外暴露
	export default {
		// 组件名
		name: "Login",
		
		/**
		 * @Des 组件 注册
		 * @Auth CC
		 * @Date 2021/6/1
		 * */
		components: {
			// 验证码
			ValidCode,
			// 组件 授权
			WarrantDialog,
		},
		
		// 数据
		data() {
			return {
				
				projectName: '',
				
				// 校验规则
				rules: {
					username: [{
						validator: (rule, value, callback) => {
							if (checkEmpty(value)) {
								new callback(new Error('请输入用户名'))
							} else {
								callback()
							}
						},
						trigger: "blur"
					}],
					password: [{
						validator: (rule, value, callback) => {
							if (checkEmpty(value)) {
								new callback(new Error('请输入密码'));
							} else {
								callback()
							}
						},
						trigger: "blur"
					}],
					
					vCode: [{
						validator: (rule, value, callback) => {
							callback()
							return false;
							if (checkEmpty(value)) {
								new callback(new Error('请输入验证码'));
							} else if (this.vCodeForm.value.toUpperCase() != this.loginForm.vCode.toUpperCase()) {
								new callback(new Error("验证码错误"));
							} else {
								callback()
							}
						},
						trigger: "blur"
					}]
				},// rules
				
				// 当前表单
				onForm: 'loginForm',
				// 记录notify
				notifyForm: {},
				
				// loading
				loading: null,
				
				// 公钥
				publicKey: '',
				
				/**
				 * @Des validCode
				 * @Auth CC
				 * @Date 2021/5/14
				 * */
				vCodeForm: {
					width: '120px',
					height: '40px',
					length: 4,
					refresh: 0,
					value: null
				},// vCodeForm
				
				// 表单信息 登录
				loginForm: {
					roleType: 1,// 1 内部用户；2 外部用户
					username: '',
					password: '',
					// 验证码
					vCode: null,
					// 显示密码
					showPwd: false,
					// 错误信息
					errmsg: null,
					isFull: 0,
					autologin: 0,
				},// loginForm
				
				// 登录信息
				loginInfo: null,
				// 登录锁
				locked: false,
				// 登录类型
				loginType: 0,
				// 自动登录
				autologin: false,
				// 是否全屏
				isFull: false,
				
				// 选择项目
				filters: {
					// 表单展示 flag
					visibleFlag: false,
					// 当前账户关联项目
					projects: [],
					// 当前项目
					currProjectId: '',
					// 当前项目name
					currProjectName: '',
					// 菜单类型
					showType: 100,// '',
				},// filters
				// 链接参数
				queryParams: {},
			}
		},// data()
		
//		// 计算
//		computed: {
//			//数组形式
//			...mapState([
//				// 需要和state中定义的变量相同
//				"userRouter"
//			]),
//		},
		
		// 调用方法
		methods: {
			
			showFullHandle(v) {
				this.isFull = v==1?true:false;
			},
			
			autoLoginHandle(v) {
				this.autologin = v==1?true:false;
			},
			
			// 关闭信息弹窗
			closeAllNotify() {
				// 关闭信息弹窗
				this.$notify.closeAll();
				// 记录notify
				this.notifyForm = {};
			},
			
			/**
			 * @Des 显示密码
			 * @Auth CC
			 * @Date 2021/6/02
			 * */
			togglePwdType() {
				// 显示密码 flag
				this.loginForm.showPwd = !this.loginForm.showPwd;
			},
			
			// 登录
			login(usernameSecret = '', passwordSecret = '') {
				// 验证 请求锁
				if (this.locked) return;
				
				this.closeAllNotify();
				
				// 登录失败，提示错误信息
				this.loginForm.errmsg = null;
				this.loginType = 0;
				
				if(usernameSecret == '' && passwordSecret == ''){
					this.$refs.loginForm.validate(valid => {
						if(!valid) return false;
						
						// loading
						this.loading = this.$loading({
							lock: true,
							text: '正在登录...',
							spinner: 'el-icon-loading',
							background: 'rgba(0, 0, 0, 0.7)'
						});
						
						let username = this.loginForm.username.trim();
						let password = this.loginForm.password.trim();
						this.getPublicKey(username, password);
						
					})
				}else{
					// loading
					this.loading = this.$loading({
						lock: true,
						text: '正在登录...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					
					this.requestLogin(usernameSecret, passwordSecret);
				}
			},// login
			
			// 单点登录
			ssoLogin(ssoid='') {
				// 验证 请求锁
				if(this.locked) return;
				// 关闭信息弹窗
				this.closeAllNotify();
				// 登录失败，提示错误信息
				this.loginForm.errmsg = null;
				if(ssoid != ''){
					// 交互锁
					this.locked = true;
					this.loginType = 1;
					this.loading = this.$loading({
						lock: true,
						text: '自动登录中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					setTimeout(()=>{
						this.requestLogin('','', this.loginType, ssoid);
					},1500);
				}
			},// ssoLogin
			
			// 登录请求
			requestLogin(usernameSecret, passwordSecret, type = 0, ssoid = '') {
				// 交互锁
				this.locked = true;
				// 打开登录锁，防止重复提交
				this.$request.postJsonRequest(ApiOam.Login_Uri, {
					"username": usernameSecret,
					"password": passwordSecret,
					type: type,
					ssoid: ssoid,
				}).then(result => {
					// 交互锁
					this.locked = false;
					// 关闭 loading
					this.loading && this.loading.close();
					
					// console.log(result)
					// 返回结果
					if (result.code == 0) {
						// 登录信息
                        this.loginInfo = Object.assign({}, result.data);
                        // 记录 uuid
                        this.$store.dispatch("commitUuid", result.data.uuid);
						// 保存账户授权码、应用ID、语言
						this.$store.dispatch("commitToken", this.loginInfo.authCode);
						this.$store.dispatch("commitLoginDevice", this.loginInfo.loginDevice);
						this.$store.dispatch("commitLang", this.loginInfo.lang);
						
						this.usernameSecret = usernameSecret;
                        this.passwordSecret = passwordSecret;
						
						// 存储登录信息
						this.storeLoginInfo();
						
						return false;
						// 用户关联项目
						const userProject = JSON.parse(result.data.userProject);
						// 初始化项目表单
						this.initProjects(this.$checkEmpty(userProject) ? [] : userProject);
						
						// 查找可访问的菜单
						// this.searchMenu();
						
					} else {
						// 登录失败，提示错误信息
						this.loginForm.errmsg = result.msg;
						// 刷新验证码
						this.vCodeForm.refresh++;
						
						// 移除cookie
						this.removeCookies();
					}
				}).catch(error => {
					// 交互锁
					this.locked = false;
					// 移除cookie
					this.removeCookies();
					// 关闭 loading
					this.loading && this.loading.close();
					console.error('登录异常', ApiOam.Login_Uri, error);
				})
			},// requestLogin
			
			getPublicKey(username, password) {
				// 交互锁
				if (this.locked) return false;
				
				// 交互锁
				this.locked = true;
				this.$request.postJsonRequest(ApiOam.Get_PublicKey_Uri, {
					random: Math.random()
				}).then(result => {
					// 交互锁
					this.locked = false;
					
					// console.log(result);
					// 返回结果
					if (result.code == 0) {
						// 获取成功
						this.publicKey = result.data;
						//检索登录状态
						this.checkLogin();
						let usernameSecret = Secret.encryptRSA(username, this.publicKey);
						let passwordSecret = Secret.encryptRSA(password, this.publicKey);
						// 登录
						this.requestLogin(usernameSecret, passwordSecret);
					} else {
						// 获取失败，提示错误信息
						this.$message({
							message: result.msg,
							type: 'error',
							showClose: true,
							dangerouslyUseHTMLString: true
						});
					}
				}).catch(error => {
					// 交互锁
					this.locked = false;
					// 关闭 loading
					this.loading && this.loading.close();
					console.error('获取公钥异常', ApiOam.Get_PublicKey_Uri, error);
				})
			},// getPublicKey
			
			/**
			 * @Des 存储登录信息
			 * @Auth 
			 * @Date 
			 */
			storeLoginInfo() {
				let userRole = [{name: this.loginInfo.roleName, id: this.loginInfo.roleId}];// this.loginInfo.userRole
				this.$store.dispatch("commitUserRole", JSON.stringify(userRole));
				this.$store.dispatch("commitUserName", this.loginInfo.userName);
				this.$store.dispatch("commitAccountId", this.loginInfo.accountId);
				this.$store.dispatch("commitFullscreen", this.isFull);
				this.$store.dispatch("commitAutoLogin", this.autologin);
				this.$store.dispatch("commitLoginIp", this.loginInfo.loginIp==null?"":this.loginInfo.loginIp);
				this.$store.dispatch("commitLoginKey", this.loginInfo.loginKey==null?"":this.loginInfo.loginKey);
				this.$store.dispatch("commitLoginCity", this.loginInfo.loginCity==null?"":this.loginInfo.loginCity);
				
				// uwb 继续记录
				this.$store.dispatch("commitAccount", this.loginInfo.account);
				this.$store.dispatch("commitUserProject", this.loginInfo.userProject);
				// this.$store.dispatch("commitUserArea", this.loginInfo.userArea);
				this.$store.dispatch("commitUserAdminRole", this.loginInfo.userAdminRole);
				this.$store.dispatch("commitIsAuthorized", this.loginInfo.isAuthorized);// this.loginInfo.isAuthorized
				
				// 记录资源路由
				this.$store.dispatch("commitUserRouter", JSON.stringify(['/manager/index']));

				// 记住密码
				if (this.autologin) {
					// cookie 记录
					this.$cookies.set("username", this.loginForm.username.trim(), {expires: 7});
					this.$cookies.set("usernameSecret", this.usernameSecret, {expires: 7});
					this.$cookies.set("passwordSecret", this.passwordSecret, {expires: 7});
				}
				
				// 记录当前项目
				this.$store.dispatch("commitCurrentProjectId", this.filters.currProjectId);// 记录当前项目 id
				this.$store.dispatch("commitCurrentProjectName", this.filters.currProjectName);// 记录当前项目 名称
				this.$store.dispatch("commitShowType", this.filters.showType);// 记录当前项目 名称


				// 销毁 keyup监听
				this.destroyed();
				// 是否开启全屏
				if (this.loginType != 1) {
					if (this.isFull) {
						GlobalFun.fullscreen();
					} else {
						GlobalFun.exitFullscreen();
					}
				}
				// 跳转到 manager/subApp 路由
				this.$router.replace({path: this.$store.state.homePage}, () => {}, () => {});
			},
			
			//检索登录状态
			checkLogin() {
				
				// 账户id为空 初始化状态记录
				// this.$checkEmpty(this.$store.state.accountId) && this.removeStorage();
				
				const isPc = this.$checkLoginDevice('pc');
				
				if (!isPc && false) {
					
					// 记录登录设备 1 PC； 2  移动端
					this.$store.dispatch("commitLoginDevice", 2);
					
				// 正在请求 中止
				} else {
					// 记录登录设备 1 PC； 2  移动端
					this.$store.dispatch("commitLoginDevice", 1);
				}
			},// checkLogin
			
			keyUp(e) {
				//如果是回车则执行登录方法
				if (e.keyCode == 13) {
					this.login();
				}
			},
			destroyed() {
				window.removeEventListener('keyup', this.keyUp, false);
			},
			// 移除cookie
			removeCookies() {
				this.$cookies.remove("username");
				this.$cookies.remove("usernameSecret");
				this.$cookies.remove("passwordSecret");
			},
			searchMenu() {
				this.$request.postJsonRequest(ApiOam.Search_Role_Resources_Uri, {
					Role: this.$store.state.userRole,
					showType: this.$store.state.showType, // 20,// 1 隧道； 2 通用版； 100 库存
					resourceTypes: [1]
				}).then(result => {
					// console.log(result);
					
					let userRouter = [];
					if (result.total > 0) {
						
						let rows = GlobalFun.dataToTree(Object.assign([], result.rows), {
							id: 'resourceId',
							pid: 'resourceParentId',
							children: 'children',
							icon: 'resourceIcons',
							path: 'resourceUri',
							name: 'resourceName'
						});
						// 遍历 一级菜单
						rows.forEach((row, index) => {
							// 有二级菜单
							if (!this.$checkEmpty(row.children)) {
								// 遍历 二级菜单
								row.children.forEach((r, i) => {
									if (!this.$checkEmpty(r.resourceUri)) {
										// 二级菜单 有地址
										userRouter.push(r.resourceUri);
									}
								});
							} else if (!this.$checkEmpty(row.resourceUri)) {
								// 一级菜单有地址
								userRouter.push(row.resourceUri);
							}
						});
					}
					this.$store.dispatch("commitUserRouter", JSON.stringify(userRouter));
					
					// 无权限 中止
					if (this.$checkEmpty(userRouter)) {
						this.$message('暂无访问权限！');
						return false;
					}
					
					// 跳转到 manager/subApp 路由
					this.$router.replace({path: userRouter[0]}, () => {}, () => {});
					
				}).catch(error => {
					console.error('查询资源异常', ApiOam.Search_Role_Resources_Uri, error);
				})
			},// searchMenu
			
			// 数组形式, 此方法只能写在 methods里面，在其他地方调用即可
			...mapMutations([
				'removeUserRole',
				'removeUserName',
				'removeAccount',
				'removeAccountId',
				'removeUserProject',
				'removeUserAdminRole',
				'removeIsAuthorized',
				'removeUuid',
				'removeUserRouter',
				'commitUserRouter',
				'commitFullscreen',
				'commitAutoLogin',
				'commitCurrentProjectId',
				'commitUserProject',
			]),// ...mapMutations
			// 移除状态记录
			removeStorage() {
				// 移除授权码
				this.removeUserRole();
				this.removeUserName();
				this.removeAccount();
				this.removeAccountId();
				this.removeUserProject();
				this.removeUserAdminRole();
				this.removeIsAuthorized();
				this.removeUuid();
				this.removeUserRouter();
				
				this.$store.dispatch("commitToken", '1');
				this.$store.dispatch("commitLang", 'zh');
			},// removeStorage
			
			// ================================= 选择项目 start ================================= \\
			/**
			 * @Description 选项改变
			 * @Author
			 * @Time
			 * */
			radioChange() {
				// 空值
				if (this.$checkEmpty(this.filters.currProjectId)) {
					// 当前项目name
					this.filters.currProjectName = '';
					this.filters.showType = '';
					return false;
				}
				
				// 记录 rows
				const rows = Object.assign([], this.filters.projects);
				// 遍历
				rows.forEach((row, index) => {
					// 空值 跳过
					if (this.$checkEmpty(row) || this.$checkEmpty(row.id) || this.$checkEmpty(row.name)) {
						return true;
					}
					
					// 匹配项目id
					if (this.filters.currProjectId == row.id) {
						// 当前项目name
						this.filters.currProjectName = row.name;
						this.filters.showType = row.showType;
					}
				
				});
				
			},// radioChange
			
			/**
			 * @Description 初始化项目表单
			 * @Author
			 * @Time
			 * */
			initProjects(_rows) {
				// 空值
				if (this.$checkEmpty(_rows)) {
					this.$message('账户未绑定项目');
					return false;
				}
				
				let rows = [];// 记录list数据
				// 检索 rows
				if (typeof _rows == 'string') {
					rows = JSON.parse(_rows);
				} else {
					rows = Object.assign([], _rows);
				}
				
				// 当前账户关联项目
				this.filters.projects = Object.assign([], rows);
				var exitFlag = false;
				if(this.$store.state.currentProjectId){
					Object.assign([], rows).forEach((row, index) => {
						// projectId 匹配
						if (!exitFlag && this.$store.state.currentProjectId == row.id) {
							// 当前项目id
							this.filters.currProjectId = row.id;
							// 当前项目name
							this.filters.currProjectName = row.name;
							// 当前项目name
							this.filters.showType = row.showType;

							exitFlag = true;
						}
					});
					
					// projectId 不匹配
					if (!exitFlag) {
						// 当前项目id
						this.filters.currProjectId = rows[0]['id'];
						// 当前项目name
						this.filters.currProjectName = rows[0]['name'];
						// 当前项目name
						this.filters.showType = rows[0]['showType'];
					}
				
				}else{
					// 当前项目id
					this.filters.currProjectId = rows[0]['id'];
					// 当前项目name
					this.filters.currProjectName = rows[0]['name'];
					// 当前项目name
					this.filters.showType = rows[0]['showType'];
				}
				
				if (rows.length == 1 || (this.queryParams.projectId && exitFlag)) {
					// 进入项目
					this.intoProject();
					return false;
				}
				
				// 表单展示 flag
				this.filters.visibleFlag = true;
			},// initProjects
			
			/**
			 * @Description 进入项目
			 * @Author
			 * @Time
			 * */
			intoProject() {
				// 表单展示 flag
				this.filters.visibleFlag = false;
				
				if (this.loginInfo.isAuthorized == 1) {
					// 存储登录信息
					this.storeLoginInfo();
				} else {
					// 是否授权
					this.isAuth();
				}
			},
			
			/**
			 * @Description 是否授权
			 * @Author
			 * @Time
			 */
			isAuth() {
				if (this.locked) return false;
				
				// loading
				this.loading = this.$loading({
					lock: true,
					text: '正在加载授权信息...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				
				// 交互锁
				this.locked = true;
				this.$request.postJsonRequest(ApiOam.Is_Auth_Uri, {
                    systemType: 2,// 1运维平台	2 应用平台
                    projectId: this.filters.currProjectId,
                }).then( result => {
                	// 交互锁
                	this.locked = false;
                	// 关闭 loading
					this.loading && this.loading.close();
                	
                    // 返回结果
                    if(result.code == 0) {
                        // 存储登录信息
                        this.storeLoginInfo();
                    } else {
                        // 授权弹窗
                    	this.$refs.warrantDialog.openDialog({
                    		projectId: this.filters.currProjectId,
                    		projectName: this.filters.currProjectName,
                    	});
                    }
                }).catch(error => {
                	// 交互锁
                	this.locked = false;
                    
                    // 移除cookie
                    this.removeCookies();
                    // 关闭 loading
					this.loading && this.loading.close();
					
					console.error('查询授权权限异常', ApiOam.Is_Auth_Uri, error);
                })
			},// isAuth
			
			/**
			 * @Description 放弃登录
			 * @Author
			 * @Time
			 * */
			cancleLogin() {
				// 清除filter数据
				this.cleanFilter();
				// 移除状态记录
				this.removeStorage();
			},
			
			/**
			 * @Description 清除filter数据
			 * @Author
			 * @Time
			 */
			cleanFilter() {
				// 选择项目
				
				// 表单展示 flag
				this.filters.visibleFlag = false;
				// 当前账户关联项目
				this.filters.projects = [];
				// 当前项目id
				this.filters.currProjectId = '';
				// 当前项目name
				this.filters.currProjectName = '';
				this.filters.showType = 100;// '';
			},// cleanFilter
			
			// ================================= 选择项目 end ================================= \\
		},// methods
		
		created() {
			
		},// created
		
		mounted() {
			// cookie 记录
			// var username = this.$cookies.get("username");
			// var usernameSecret = this.$cookies.get("usernameSecret");
			// var passwordSecret = this.$cookies.get("passwordSecret");
			this.isFull = this.$store.state.fullscreen;// GlobalFun.isFullscreen();
			this.loginForm.isFull = this.isFull ? 1 : 0;
			this.$store.dispatch("commitFullscreen", this.isFull);
			
			this.autologin = this.$store.state.autoLogin;
			this.loginForm.autologin = this.autologin ? 1 : 0;
			
			let ssoid = '';
			// 单点登录
			var url = window.location.href;
			if(url.indexOf("?") != -1) {
				
				// const param = url.substring(url.indexOf("?")+1,url.indexOf("#/"));
				const param = url.split('?')[1].split('#')[0];
				
				const paramArray = param.split('&');//参数字符串分割为数组
				let params={};
				
				for(var i=0;i<paramArray.length;i++){//遍历数组，拿到json对象
					let pA = paramArray[i].split("=");
					params[pA[0]] = pA[1];
				}
				// 链接 参数
				this.queryParams = Object.assign({}, params);
				
				// 获取参数
				let ssoid = params.ssoid || params.accountId;
				let projectId = params.projectId;
				let projectName = decodeURI(params.projectName);
				
				if(projectId && projectId != 'undefined'){
					this.$store.dispatch("commitCurrentProjectId", projectId);
				}
				
				if(projectName && projectName != 'undefined'){
					this.$store.dispatch("commitCurrentProjectName", projectName);
					this.projectName = projectName;
				}
				
				this.$store.dispatch("commitAutoLogin", true);
				
				this.$store.dispatch("commitAccountId", ssoid);
				
				this.ssoLogin(ssoid);
				
				// window.location.href = '/';
				return;
			
			}// if(url.indexOf("?") != -1)
			
			if (this.autologin) {
				if (!ssoid || ssoid == undefined) {
					ssoid = this.$store.state.accountId;
				}
			}
			
			if (ssoid == '') {
				// 移除状态记录
				this.removeStorage();
				// this.getPublicKey();
				window.addEventListener('keyup', this.keyUp);
			} else {
				this.ssoLogin(ssoid);
			}
			
			// 关闭信息弹窗
			this.closeAllNotify()
		},// mounted
		
	}// export default
</script>

/* CSS */
<style src="@/static_dazzle/css/login/login.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
	/deep/ .el-dialog__wrapper {
		background-color: rgba(0, 0, 0, 0.6);
	}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue